export default function AnyIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7772_26511)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 0C3.5816 0 0 3.5816 0 8C0 12.4184 3.5816 16 8 16C12.4184 16 16 12.4184 16 8C16 3.5816 12.4184 0 8 0Z"
          fill="#2F302F"
          fillOpacity="0.2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.89116 5.89097C7.24142 4.54071 7.99999 2.70936 7.99999 0.799805C7.99999 2.70936 8.75856 4.54071 10.1088 5.89097C11.4591 7.24124 13.2904 7.9998 15.2 7.9998C13.2904 7.9998 11.4591 8.75837 10.1088 10.1086C8.75856 11.4589 7.99999 13.2902 7.99999 15.1998C7.99999 13.2902 7.24142 11.4589 5.89116 10.1086C4.54089 8.75837 2.70955 7.9998 0.799988 7.9998C2.70955 7.9998 4.54089 7.24124 5.89116 5.89097Z"
          fill="#191A18"
          fillOpacity="0.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_7772_26511">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>

    // <svg
    //   width="24"
    //   height="24"
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 10.5858L13.4142 12L12 13.4142L10.5858 12L12 10.5858ZM12 7.75732L13.4142 9.17154L14.8284 10.5858L16.2426 12L14.8284 13.4142L13.4142 14.8284L12 16.2426L10.5858 14.8284L9.17157 13.4142L7.75736 12L9.17157 10.5858L10.5858 9.17154L12 7.75732Z"
    //     fill="#3C3C3C"
    //   />
    // </svg>
  );
}
